<div class="bufr-container">
  <!-- Render each item in the repeated array -->
  <div class="bufr-item" *ngFor="let f of field.fieldGroup; let i = index; trackBy: trackByIndex">
  
    <span *ngIf="i==0"><b>For every Product selected where this is true:</b></span>
    <span *ngIf="i>0"><b>... and this is true:</b></span>

    <!-- Render the inner fields for the i-th item -->
    <formly-field [field]="f"></formly-field>

    <!-- Per-item actions (Remove button) -->
    <div class="align-filters">
      <button type="button" class="btn btn-light btn-size" (click)="remove(i)" [disabled]="to?.disableRemove === true">Remove
        Filter</button>
      <div class="filter-separator">
        <hr>
      </div>
    </div>
  </div>
  <!-- Global Add button -->
  <div class="bufr-item align-filters">
    <br>
    <button type="button" class="btn btn-light btn-size" (click)="add()">Create Filter
    </button>
  </div>
</div>
